import * as React from 'react';
import { Nav, Navbar, Container } from 'react-bootstrap';

import { TempTab } from './components/temp_tab';
import { ClimateTab } from './components/climate_tab';
import { PiTab } from './components/pi_tab';

export const App = () => {
  const [selectedTab, selectTab] = React.useState('#temp');
  const styles = {
    grid: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  };

  return (
    <Container fluid style={styles.grid}>
      <Navbar bg="light" expand="sm" onSelect={(eventKey) => selectTab(eventKey!)}>
        <Navbar.Brand>Ingliste</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto" defaultActiveKey="#temp">
            <Nav.Link eventKey="#temp">Temp</Nav.Link>
            <Nav.Link eventKey="#kliima">Kliima</Nav.Link>
            <Nav.Link eventKey="#pi">Pi</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {(() => {
        switch (selectedTab) {
          case '#temp':
            return <TempTab />;
          case '#kliima':
            return <ClimateTab />;
          case '#pi':
            return <PiTab />;
          default:
            return <TempTab />;
        }
      })()}
    </Container>
  );
};
